import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export type LastShopSummary = {
  id:               string
  confirmedAt:      string
  storeName:        string | null  // TODO: add store_name column to shopping_lists
  totalSpent:       number | null  // TODO: add total_spent column to shopping_lists
  itemCount:        number
  itemNamesPreview: string[]
} | null

export function useLastShopSummary(householdId: string | null): {
  summary: LastShopSummary
  loading: boolean
} {
  const [summary, setSummary] = useState<LastShopSummary>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!householdId) { setLoading(false); return }

    let cancelled = false
    setLoading(true)

    ;(async () => {
      const { data, error } = await supabase
        .from('shopping_lists')
        .select(`
          id,
          completed_at,
          list_items(
            pantry_items(name)
          )
        `)
        .eq('household_id', householdId)
        .not('completed_at', 'is', null)
        .order('completed_at', { ascending: false })
        .limit(1)
        .maybeSingle()

      if (cancelled) return

      if (error || !data) { setSummary(null); setLoading(false); return }

      const names: string[] = (data.list_items ?? [])
        .map((r: any) => (r.pantry_items as any)?.name)
        .filter(Boolean)

      setSummary({
        id:               data.id,
        confirmedAt:      data.completed_at,
        storeName:        null,   // TODO: add store_name to shopping_lists
        totalSpent:       null,   // TODO: add total_spent to shopping_lists
        itemCount:        names.length,
        itemNamesPreview: names.slice(0, 5),
      })
      setLoading(false)
    })()

    return () => { cancelled = true }
  }, [householdId])

  return { summary, loading }
}
